import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fb0cd5f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fb0cd5f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0cd5f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb0cd5f8')) {
      api.createRecord('fb0cd5f8', component.options)
    } else {
      api.reload('fb0cd5f8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fb0cd5f8&scoped=true", function () {
      api.rerender('fb0cd5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/goodPriceManagement/index.vue"
export default component.exports